import { render, staticRenderFns } from "./ITab.vue?vue&type=template&id=784a5c2e&"
import script from "./ITab.vue?vue&type=script&lang=js&"
export * from "./ITab.vue?vue&type=script&lang=js&"
import style0 from "./ITab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports